import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { Skeleton } from '~/components';
import { AppliedFilter } from '~settings/components/AppliedFilter';
import { useAppliedFilters } from '~settings/components/FilterList/hooks/useAppliedFilters';
import { ScrollableRows } from '~settings/components/Scrollable/ScrollableRows';

function FilterList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation('settings');
  const { filters: selectedFilters, isLoading } = useAppliedFilters();

  const handleDelete = (key: string, value: string) => {
    const currList = searchParams.get(key)?.split(',');

    if (!currList) {
      return;
    }

    const newList = currList.filter((val) => val !== value);

    if (newList.length) {
      searchParams.set(key, newList.join(','));
    } else {
      searchParams.delete(key);
    }

    setSearchParams(searchParams);
  };

  if (isLoading) {
    return (
      <div className="flex gap-sm" data-testid="skeleton-loader">
        <Skeleton className="h-lg w-5xl rounded-xs bg-emphasis-default" />
        <Skeleton className="h-lg w-3xl rounded-xs bg-emphasis-default" />
      </div>
    );
  }

  if (!selectedFilters?.length) {
    return (
      <div
        className="h-full items-center text-body-sm text-subtle"
        data-testid="applied-filters-list"
      >
        {t('noFilters')}
      </div>
    );
  }

  return (
    <ScrollableRows data-testid="applied-filters-list">
      {selectedFilters.map((tagInfo) => (
        <AppliedFilter
          key={`${tagInfo.label}-${tagInfo.value}`}
          {...tagInfo}
          onRemove={handleDelete}
        />
      ))}
    </ScrollableRows>
  );
}

FilterList.displayName = 'FilterList';
export { FilterList };
